import styled from 'styled-components';

export const ContainerInputSenha = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ListagemCondicionaisSenha = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[2]}px;
`;

export const CheckboxGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[3]}px;
`;

export const ButtonTermos = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: none;
`;

export const ContainerTextos = styled.div`
  display: inline;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[1]}px;
`;
